import React from 'react';
const IconCommentBlank = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 16H4V4H20V16H14.53L9.5 22H12.11L15.47 18H22V2H2V18H10V16Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconCommentBlank;